import titlesMock from '../data/infoJson/titles.json'
import subtitlesMock from '../data/infoJson/subtitles.json'
import informationMock from '../data/infoJson/information.json'
import formMock from '../data/formJson/form.json'
import formFieldsMock from '../data/formJson/formFields.json'
import tagsZendeskMock from '../data/formJson/tagZendesk.json'

export const infoArrive = (infoFile) => {
    return Object.keys(infoFile).length > 0
}

export function CallDataWinterSoldier(setTitlesData, setSubtitlesData, setInfoData, alreadyAskFetch, setAlreadyAskFetch){
    if(alreadyAskFetch) {
        try {
            setAlreadyAskFetch(false)
            if (process.env.NODE_ENV !== 'development') {
                fetch(`${process.env.PUBLIC_URL}/data/infoJson/titles.json`)
                    .then((r) => r.json())
                    .then((data) => setTitlesData(data))
                fetch(`${process.env.PUBLIC_URL}/data/infoJson/subtitles.json`)
                    .then((r) => r.json())
                    .then(data => setSubtitlesData(data))
                fetch(`${process.env.PUBLIC_URL}/data/infoJson/information.json`)
                    .then((r) => r.json())
                    .then(data => setInfoData(data))
            } else {
                setTitlesData(titlesMock)
                setSubtitlesData(subtitlesMock)
                setInfoData(informationMock)
            }
        } catch (err) {
            console.log(err)
        }
    }
}

export function CallFormWinterSoldier(setFormJson, setFormFieldsJson, setTagZendeskJson, alreadyAskFetch, setAlreadyAskFetch) {
    if(alreadyAskFetch) {
        try {
            setAlreadyAskFetch(false)
            if (process.env.NODE_ENV !== 'development') {
                fetch(`${process.env.PUBLIC_URL}/data/formJson/form.json`)
                    .then((r) => r.json())
                    .then(resp => setFormJson(resp))
                fetch(`${process.env.PUBLIC_URL}/data/formJson/formFields.json`)
                    .then((r) => r.json())
                    .then(resp => setFormFieldsJson(resp))
                fetch(`${process.env.PUBLIC_URL}/data/formJson/tagZendesk.json`)
                    .then((r) => r.json())
                    .then(resp => setTagZendeskJson(resp))
            } else {
                setFormJson(formMock)
                setFormFieldsJson(formFieldsMock)
                setTagZendeskJson(tagsZendeskMock)
            }
        } catch (err) {
            console.log(err)
        }
    }
}

export function CallOnlyFormWinterSoldier(setFormJson, alreadyAskFetchForm, setAlreadyAskFetchForm) {
    if(alreadyAskFetchForm) {
        try {
            setAlreadyAskFetchForm(false)
            if (process.env.NODE_ENV !== 'development') {
                fetch(`${process.env.PUBLIC_URL}/data/formJson/form.json`)
                    .then((r) => r.json())
                    .then(resp => setFormJson(resp))
            } else {
                setFormJson(formMock)
            }
        } catch (err) {
            console.log(err)
        }
    }
}

export function validUrlsFunction(subtitlesData, formJson, alreadyAskValidUrl, setAlreadyAskValidUrl) {
    if(alreadyAskValidUrl && infoArrive(subtitlesData) && infoArrive(formJson)){
        setAlreadyAskValidUrl(false)
        const result = []
        subtitlesData.filter(info => {
            if(result.indexOf(info.urltitlefather) === -1){
                result.push(info.urltitlefather)
            }
            if(result.indexOf(info.urltitle) === -1){
                result.push(info.urltitle)
            }
            return null
        })

        if(formJson && Object.keys(formJson).length!==0){
            formJson.filter(info => {
                result.push(`contact-us/${info.id}`)
                return null
            })
        }
        return result
    }
    return null
}

export const removeAccents = (str) => {
    return str && str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export const capitalize = (word) => {
    return word && word[0].toUpperCase() + word.slice(1);
}

export const GetSortOrder = (prop) => {
    return function(a, b) {
        if (a[prop] < b[prop]) {
            return 1;
        } else if (a[prop] > b[prop]) {
            return -1;
        }
        return 0;
    }
}

export const thisSymbolComesFirst = (content, otherSymbols, symbol) => {
    if( content.indexOf(symbol) === -1) return false

    const indexSymbolOne = {name: otherSymbols[0], index : content.indexOf(otherSymbols[0])}
    const indexSymbolTwo = {name: otherSymbols[1], index : content.indexOf(otherSymbols[1])}
    const indexSymbolThree = {name: otherSymbols[2], index : content.indexOf(otherSymbols[2])}
    const indexSymbolFour = {name: otherSymbols[3], index : content.indexOf(otherSymbols[3])}
    const orderSymbols = [indexSymbolOne, indexSymbolTwo, indexSymbolThree, indexSymbolFour]
    const presentSymbols = orderSymbols.filter(symbol => symbol.index !== -1)
    const isOtherSymbolsComesLater = presentSymbols.map(presentSymbol => content.indexOf(symbol) < presentSymbol.index)
    const isEveryOtherSymbolComesLater = isOtherSymbolsComesLater.every(function(e){return e})

    if( isEveryOtherSymbolComesLater || (
        indexSymbolOne === -1 && indexSymbolTwo === -1 && indexSymbolThree === -1 && indexSymbolFour === -1
    )){
        return true
    }

    return false
}